import React from "react"
import { BodyText, InlineText, SubTitle } from "../../Typography/Typography"
import SmartLink from "../../layout/SmartLink/SmartLink"

const providerProfileClickEvent = () => ({
  name: "SEO Filtered Directory - Copy link to provider clicked",
  properties: {
    "Care Type": "care_home",
    "GEO Location": "Nottingham",
    "Current URL":
      "https://www.caresourcer.com/s/providers/towns/nottingham/care-home/",
  },
})

export default {
  summary: (
    <BodyText marginBottom>
      Choosing a care home for a loved one can be difficult, however with over
      160 care homes in Nottingham, and 113 offering specialist dementia care,
      it is important you make the right decision on which care home is best for
      your loved one’s needs. Here are a few of our top tips to help you narrow
      your options.
    </BodyText>
  ),
  content: [
    <SubTitle marginBottom bold>
      Location is key
    </SubTitle>,
    <BodyText marginBottom>
      Consider what area your loved one would like to live in and also how
      accessible this will be for friends and family to visit. Most care homes
      in Nottingham have car parks and are close to public transport links,
      however, we recommend calling some of the homes on your shortlist and
      learning about the travel options available. With so many care homes to
      choose from in Nottingham, there are many located centrally in Carrington
      or near Forest Recreation Ground. However, if your loved one would like a
      little more green space, for only a short 10-minute drive you can find
      homes like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-140486563/hall-park-care-home"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Hall Park Care Home</InlineText>
      </SmartLink>
      , which offer the best of both worlds.
    </BodyText>,
    <SubTitle marginBottom bold>
      Feeling at home
    </SubTitle>,
    <BodyText marginBottom>
      Moving into a care home can be daunting. The process of leaving behind
      your home and entering new surroundings is unsettling for some. Below are
      a few things to consider that will make this change as smooth as possible
      for your loved one:
    </BodyText>,
    <SubTitle marginBottom bold italic>
      Gardens and outdoor spaces
    </SubTitle>,
    <BodyText marginBottom>
      Speak to your loved one and find out how important outdoor space is to
      them, and what about it makes it that way. For example, are they looking
      for a quiet space to sit in with visitors? Then perhaps a home with a nice
      patio space like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-310139890/charnwood"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Charnwood</InlineText>
      </SmartLink>
      , near Carlton railway station would suit. Or, do they enjoy pottering in
      the garden? Then perhaps a home like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-2232775564/fairway-view"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Fairway View</InlineText>
      </SmartLink>{" "}
      in Bulwell, with lovely landscaped sensory gardens would suit better, even
      if slightly further out of the city centre?
    </BodyText>,
    <BodyText marginBottom bold italic>
      Pets welcome
    </BodyText>,
    <BodyText marginBottom>
      Does your loved one have a pet they are worried about leaving when moving
      into a care home? With almost 100 pet-friendly care homes in Nottingham,
      we recommend asking about their pet policies as many allow pets to move in
      with their owner and others, like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-126240125/annesley-lodge-care-home"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Annesley Lodge Care Home</InlineText>
      </SmartLink>
      , allow pets to visit frequently.
    </BodyText>,
    <BodyText marginBottom bold italic>
      Activities and days out
    </BodyText>,
    <BodyText marginBottom>
      To help residents feel at home and continue their hobbies, most care homes
      in Nottingham offer a wide range of activities and facilities. Many, like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-1305105437/acorn-house"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Acorn House in Carrington</InlineText>
      </SmartLink>
      , encourage residents to share what they love to do or want to try; from
      flower arranging, to yoga, movie nights and music sessions, so it can help
      them feel more at home. If you can not see anything your loved one likes
      on the website, ask the home directly and they may be willing to organise
      something.
    </BodyText>,
  ],
}
